import { InjectionToken } from '@angular/core';

export interface FormsConfig {
  minDate?: Date;
  maxDate?: Date;
  minNumber?: number;
  maxNumber?: number;
}

export const FORMS_CONFIG = new InjectionToken('FormsConfig');
